import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { memo } from 'react';
import Tooltip from 'syf-component-library/ui/atoms/Tooltip';
import Inline from 'syf-component-library/ui/spacing/Inline';
import useTranslation from '../../../hooks/use-translation';
import { StyledText } from '../../../styles/text';
import { colors } from '../../../styles/theme';
const PromotionsTooltip = ({ isInteractive = false }) => {
    const t = useTranslation();
    return (_jsx(Tooltip, { isInteractive: isInteractive, content: _jsx(StyledText, { children: t('promotions.promotionalBalanceTooltip') }), children: _jsxs("span", { children: [_jsx(Inline, { size: "xsmall" }), _jsx(FontAwesomeIcon, { icon: faInfoCircle, color: colors.cyanBlue })] }) }));
};
export default memo(PromotionsTooltip);
//# sourceMappingURL=index.js.map